import Carousel from "../Carousel/Carousel";
import styles from "./MartialArts.module.css";

const martialArtsData = [
  {
    id: 1,
    img: require("../../assets/images/martialArts-img-1.png"),
    alt: "",
  },
  {
    id: 2,
    img: require("../../assets/images/martialArts-img-2.png"),
    alt: "",
  },
  {
    id: 3,
    img: require("../../assets/images/martialArts-img-3.png"),
    alt: "",
  },
  {
    id: 4,
    img: require("../../assets/images/martialArts-img-4.png"),
    alt: "",
  },
];

const MartialArts = () => {
  return <Carousel title="MartialArts" data={martialArtsData} />;
};

export default MartialArts;
